import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { useActions, useGetters, useState } from 'vuex-composition-helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Index',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const navLinks = computed(() => {
            const links = [];
            if (feed.value?.type !== 'fetch-only') {
                links.push({
                    icon: 'mdi-database-edit',
                    text: 'Query Management',
                    route: 'QueryManagement',
                });
                links.push({
                    icon: 'mdi-table-plus',
                    text: 'Additional Fields',
                    route: 'feed.extra-fields',
                });
            }
            links.push({
                icon: 'mdi-calendar-clock',
                text: 'Schedule Tasks',
                route: 'ScheduledTasks',
            }, {
                icon: 'mdi-calendar-multiple-check',
                text: 'Runs',
                route: 'feed.runs',
            }, {
                icon: 'mdi-file-document-edit-outline',
                text: 'Feed Details',
                route: 'PropertyDetails',
            });
            return links;
        });
        const drawer = ref(null);
        const { find: fetchFeeds } = useActions('feed', ['find']);
        const { find: findFeedsInStore, get: getFeedFromStore } = useGetters('feed', ['find', 'get']);
        onMounted(() => {
            fetchFeeds({ query: { $limit: 1000 } });
        });
        const feeds = computed(() => findFeedsInStore.value({}).data);
        const feed = computed(() => {
            if (!route.params.id)
                return null;
            return getFeedFromStore.value(route.params.id);
        });
        function updateRoute(item) {
            if (typeof item !== 'undefined')
                router.replace({ params: { id: item } });
        }
        const accountMenu = ref(false);
        const { user } = useState('auth', ['user']);
        const logout = () => {
            router.app.$store.dispatch('auth/logout').then(() => {
                router.push('/login');
            }).catch(() => {
                router.push('/login');
            });
        };
        function goHome() {
            router.push({ path: '/' });
        }
        return { __sfc: true, router, route, navLinks, drawer, fetchFeeds, findFeedsInStore, getFeedFromStore, feeds, feed, updateRoute, accountMenu, user, logout, goHome };
    }
});
